module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/dc685034141f1d53513e90539b4e2436.png";